<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="400"
    transition="dialog-bottom-transition"
    scrollable
  >
    <RoleInVesselDialogCreate v-if="vessel && dialog" :vessel="vessel" @close="close"></RoleInVesselDialogCreate>
  </v-dialog>
</template>

<script>
import RoleInVesselDialogCreate from '@/components/roleinvessel/dialog/Create'

export default {
  name: 'RoleInVesselDialog',
  components: {
    RoleInVesselDialogCreate
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    vessel: {
      type: Object,
      required: false,
      default: null
    }
  },

  computed: {
    dialog: {
      // getter
      get: function() {
        return this.show
      },
      // setter
      set: function(show) {
        if (false === show) {
          this.close()
        }
      }
    }
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
